import { Link, useLocation, useNavigate } from 'react-router-dom';

import logo from '@dmp/assets/icons/logo-colorful.svg';
import { Button } from '@dmp/components/ui/Button/Button';
import { ROUTE_PATHS } from '@dmp/constant';
import { UserDropdown } from '@dmp/layouts/_share_/UserDropdown/UserDropdown';
import { resetDatasetsState } from '@dmp/pages/DataCatalog/DataCatalog.store';
import { resetDataHubState } from '@dmp/pages/DataHub/DataHub.store';
import { useGlobalStore } from '@dmp/stores/globalStore';

export const TenantHeader = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const isLoggedIn = useGlobalStore((s) => s.isLoggedIn);

  const isDataHubPage = location.pathname.includes(ROUTE_PATHS.DATA_HUB);

  return (
    <div
      id="header"
      className="flex justify-between items-center py-[14px] px-3 bg-white rounded-[10px] mt-[12px] mb-[22px]"
    >
      <Link
        to={ROUTE_PATHS.LANDING_PAGE}
        className="brand-logo"
        onClick={(e) => {
          e.preventDefault();
          if (window.location.pathname === ROUTE_PATHS.LANDING_PAGE) {
            window.location.reload();
          } else {
            resetDatasetsState();
            navigate(ROUTE_PATHS.LANDING_PAGE);
          }
        }}
      >
        <img src={logo} alt="logo" className="h-[40px]" />
      </Link>

      {isLoggedIn ? (
        <div className="flex items-center gap-[32px]">
          <Button
            variant="text"
            onClick={() => {
              if (window.location.pathname === ROUTE_PATHS.DATA_HUB) {
                window.location.reload();
              } else {
                resetDataHubState();
                navigate(ROUTE_PATHS.DATA_HUB);
              }
            }}
            className={isDataHubPage ? 'active-data-hub' : ''}
          >
            Datahub
          </Button>

          <UserDropdown />
        </div>
      ) : (
        <div className="flex items-center gap-[10px]">
          <Button
            variant="primary"
            onClick={() => {
              navigate(ROUTE_PATHS.LOGIN);
            }}
          >
            Log In
          </Button>
          <Button onClick={() => navigate(ROUTE_PATHS.REGISTER)} className="hover:bg-[#5929D0]! hover:text-white!">
            Register
          </Button>
        </div>
      )}
    </div>
  );
};
